import moment from "moment";
import React, { useEffect } from "react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { numDifferentiation, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../common/app_constant";
import { SUB_DIRECTORY } from "../../../../common/constant";
import Blog from "../../../../component/blog";
import Newsletter from "../../../../component/newsletter";
import OurApp from "../../../../component/our_app";
import RecommendedPolicy from "../../../../component/recommended_policy";
import { actionDownloadClaimDoc, actionGetClaim, resetClaimDocDowanloadResponse, resetGetClaimResponse } from "./store";
import _ from 'lodash';
import { useRef } from "react";
import Loader from "../../../../component/page_loader";
import CustomerFeedback from "../../../../component/customer_feedback";
import InfromationCard from "../../../../component/information_card";
import Select from 'react-select';
import { Controller, useForm } from "react-hook-form";

const Claim = () => {
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const { control } = useForm();
    const { getClaim, downloadClaim } = useSelector((state) => ({
        ...state.claimStore
    }))
    const [claim, setClaim] = useState([])
    const [filterArr, setFilterArr] = useState([])
    const [searchPolicy, setSearchPolicy] = useState('')
    const [clicked, setClicked] = useState("0");
    const contentEl = useRef();
    const [isLoader, setLoader] = useState(true)
    const [isCustomerFeedback, setIsCustomerFeedback] = useState(false)

    const data = [
        {
            value: 'all',
            text: 'ALL',
            icon: <img src="assets/images/categories/insurance.png" height="15" width="15" />
        },
        {
            value: 'AVIATION',
            text: 'AVIATION',
            icon: <img src="assets/images/categories/aviation_ins.png" height="15" width="15" />
        },
        {
            value: 'ENERGY',
            text: 'ENERGY',
            icon: <img src="assets/images/categories/energy_ins.png" height="15" width="15" />
        },
        {
            value: 'ENGINEERING',
            text: 'ENGINEERING',
            icon: <img src="assets/images/categories/engineering_ins.png" height="15" width="15" />
        },
        {
            value: 'HEALTH',
            text: 'HEALTH',
            icon: <img src="assets/images/categories/health_ins.png" height="15" width="15" />
        },
        {
            value: 'LIABILITY',
            text: 'LIABILITY',
            icon: <img src="assets/images/categories/liability_ins.png" height="15" width="15" />
        },
        {
            value: 'MARINE',
            text: 'MARINE',
            icon: <img src="assets/images/categories/marine_ins.png" height="15" width="15" />
        },
        {
            value: 'MISCELLENOUS',
            text: 'MISCELLENOUS',
            icon: <img src="assets/images/categories/miscellaneous_ins.png" height="15" width="15" />
        },
        {
            value: 'MOTOR',
            text: 'MOTOR',
            icon: <img src="assets/images/categories/motorcycle_ins.png" height="15" width="15" />
        },
        {
            value: 'PROPERTY',
            text: 'PROPERTY',
            icon: <img src="assets/images/categories/property_ins.png" height="15" width="15" />
        },
    ];

    useEffect(() => {
        dispatch(actionGetClaim({ department_name: 'all' }))
    }, [])

    useEffect(() => {
        if (getClaim !== null) {
            dispatch(resetGetClaimResponse())
            if (getClaim.result === true) {
                setClaim(getClaim.response)
                setFilterArr(getClaim.response)
                setLoader(false)
            } else {
                setLoader(false)
                switch (getClaim.status_code) {
                    case 400:
                        toast.error(getClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getClaim])

    useEffect(() => {
        if (downloadClaim !== null) {
            dispatch(resetClaimDocDowanloadResponse())
            if (downloadClaim.result === true) {
                window.open(downloadClaim.response.claim_document_url, '_blank')
            } else {
                switch (downloadClaim.status_code) {
                    case 400:
                        toast.error(downloadClaim.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [downloadClaim])

    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked("0");
        }
        setClicked(index);
    };

    const renderDocuments = (item) => {
        var arrDoc = []

        item != null && item.length > 0 ?
            item.map((item, index) => {
                arrDoc.push(
                    <div className="col-md-6 mb-2">
                        <div className="card">
                            <div className="card-body d-flex justify-content-between">
                                <div className="col-10">
                                    <p className="mb-0">{item.actual_uploaded_file_name}</p>
                                    {/* <small>{moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')}</small> */}
                                </div>
                                <div className="col-2 text-center">
                                    <i className="fa fa-download cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            dispatch(actionDownloadClaimDoc({ dms_id: item.pivot.dms_id, claim_id: item.pivot.claim_id }))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            arrDoc.push(
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            No Documents Uploaded
                        </div>
                    </div>
                </div>
            )

        return arrDoc

    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12">
                    <nav
                        className="--bs-breadcrumb-divider: '>';"
                        aria-label="breadcrumb"
                    >
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a onClick={() => {
                                navigation('/dashboard')
                            }}>Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Claim</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    <div className="row">
                        <div class="col-md-4">
                            <div class="card-body">
                                <Controller
                                    control={control}
                                    name="category"
                                    render={({ field: { value, onChange } }) => (
                                        <Select
                                            placeholder="Select Option"
                                            options={data}
                                            defaultValue={data[0]}
                                            isSearchable={true}
                                            onChange={(e) => {
                                                dispatch(actionGetClaim({ department_name: e.value }))
                                            }}
                                            getOptionLabel={e => (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    {e.icon}
                                                    <span style={{ marginLeft: 5 }}>{e.text}</span>
                                                </div>
                                            )}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="card profile-section col-md-8">
                            <div className="card-body">
                                <form>
                                    <div class="form-group has-search">
                                        <span class="fa fa-search form-control-feedback"></span>
                                        <input
                                            type="text"
                                            name="search"
                                            class="form-control"
                                            placeholder={'Search Policy'}
                                            value={searchPolicy}
                                            onChange={(event) => {
                                                setSearchPolicy(event.target.value)
                                                var arrFilterPolicyWallet = Object.assign([], filterArr);
                                                if (event.target.value.length > 0) {
                                                    setSearchPolicy(event.target.value)
                                                    var arrFilterPolicyWallet = arrFilterPolicyWallet.filter(
                                                        (item) =>
                                                            item.Policytype.toLowerCase().includes(event.target.value.toLowerCase()) ||
                                                            item.client_name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                                                            item.policy_no.toLowerCase().includes(`${event.target.value.toLowerCase()}`)
                                                    );
                                                    setClaim(arrFilterPolicyWallet)
                                                } else {
                                                    setSearchPolicy(event.target.value)
                                                    setClaim(arrFilterPolicyWallet)

                                                }
                                            }}
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <div class="col-md-2 my-auto text-center">
                            <button class="btn btn-primary btn-sm"
                                onClick={() => {
                                    navigation('/policy-wallet/add-policy-wallet')
                                }}
                            >
                                Add Policy</button>
                        </div> */}
                    </div>
                    <div>
                        {
                            isLoader === true ?
                                <Loader />
                                :
                                claim != null && claim.length > 0 ?
                                    claim.map((item, index) => {
                                        return (
                                            <div className="row mt-4">
                                                <div className="col-md-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="accordion">
                                                                <div className="row" onClick={() => {
                                                                    handleToggle(index)
                                                                }} style={{ cursor: 'pointer' }}>
                                                                    <div className="col-1 text-center my-auto">
                                                                        <img
                                                                            src={`${SUB_DIRECTORY}/assets/images/claim.png`}
                                                                            className="w-50"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div className="col-11 col-md-5">
                                                                        <p className="mb-0 fw-600">{_.capitalize(item.client_name)}</p>
                                                                        <small>Policy NO. : {item.policy_no}</small>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2 mt-md-0">
                                                                        <p className="mb-0">Claim Amount</p>
                                                                        <p className="mb-0 fw-bold">₹ {numDifferentiation(item.amount)}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-2 text-center mt-2 mt-md-0">
                                                                        <span className="badge bg-primary rounded-pill">{_.capitalize(item.status)}</span>
                                                                    </div>
                                                                </div>

                                                                <div className="row border-top pt-2 mt-1" ref={contentEl}
                                                                    hidden={clicked === index ? false : true}>
                                                                    <div className="col-12 col-md-4 mt-2">
                                                                        <label className="card-label">Policy Type :</label>
                                                                        <p className="card-value mb-0">
                                                                            {" "}{item.Policytype}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Intimation Date :</label>
                                                                        <p className="card-value mb-0">{moment(item.intimate_date).format('DD/MM/YYYY')}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label text-primary">
                                                                            Pinc Ref. No :{" "}
                                                                        </label>
                                                                        <p className="card-value mb-0">{item.pinc_claim_ref_no}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Date of Loss</label>
                                                                        <p className="card-value mb-0">{moment(item.date_of_loss).format('DD/MM/YYYY')}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Insurer</label>
                                                                        <p className="card-value mb-0">{item.insurer}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Nature of Claim</label>
                                                                        <p className="card-value mb-0">{item.nature_of_claim}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">RM Name</label>
                                                                        <p className="card-value mb-0">{item.rm_name}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Claim Executive</label>
                                                                        <p className="card-value mb-0">{item.claim_csc_name}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Department</label>
                                                                        <p className="card-value mb-0">{item.department}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Claim Description</label>
                                                                        <p className="card-value mb-0">
                                                                            {item.loss_details}
                                                                        </p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Loss Location</label>
                                                                        <p className="card-value mb-0">{item.loss_location}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Claim Type</label>
                                                                        <p className="card-value mb-0">{item.claim_type}</p>
                                                                    </div>
                                                                    <div className="col-6 col-md-4 mt-2">
                                                                        <label className="card-label">Surveyor Name</label>
                                                                        <p className="card-value mb-0">{item.surveyor_name}</p>
                                                                    </div>
                                                                    <div className="col-12 mt-3">
                                                                        <h6>Documents({item.documents.length})</h6>
                                                                    </div>
                                                                    {renderDocuments(item.documents)}
                                                                </div>
                                                                <div className="row border-top pt-2 mt-1 fs-7">
                                                                    <div className="col-md-6 fw-bold border-end">
                                                                        Created On: <span>{moment(item?.created_at).format('DD/MM/YYYY')}</span>
                                                                    </div>
                                                                    <div className="col-md-6 fw-bold border-end">
                                                                        Modified On: <span>{moment(item?.updated_at).format('DD/MM/YYYY')}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        )
                                    })
                                    :
                                    <div className="d-flex justify-content-center align-items-center mt-5">
                                        <h5>No Claims To Display</h5>
                                    </div>

                        }

                    </div>
                </div>


                <div className="col-12 col-md-4">
                    <InfromationCard isMarginTop={false} />

                    <div class="mt-3">
                        <span class="fw-bold">Feedback</span>
                        <div class="card mt-2 shadow p-2 d-flex cursor-pointer" data-bs-toggle="modal" data-bs-target="#customerfeedback">
                            <div onClick={() => {
                                setIsCustomerFeedback(true)
                            }}>
                                <img src={`${SUB_DIRECTORY}/assets/images/icon/megaphone.png`} class="img-fluid me-3" /> <b>Customer feedback</b>
                            </div>
                        </div>
                    </div>
                    <Blog />
                </div>
            </div>

            <CustomerFeedback
                isCustomerFeedback={isCustomerFeedback}
                feedbackClose={() => {
                    window.location.reload()
                    setIsCustomerFeedback(false)
                }}
            />
        </>


    )

}

export default Claim;